  <mat-card>
      <mat-card-header>
          <mat-card-title>Dettaglio articolo</mat-card-title>
      </mat-card-header>
      <mat-card-content class="content">

        <div class="col-md-12">

          <table>
            <tr *ngIf=retrievedImage>
                <img src="{{retrievedImage}}" >
            </tr>
            <tr>
              <td>
                <input #file id="myfile" style="display:none;" type="file" accept='image/*' (change)="onFileChanged(file.files)">

                <button mat-raised-button color="primary" onclick="document.getElementById('myfile').click()">Seleziona immagine (max 50KB)</button>

              </td>
              <td>
                      <button mat-raised-button  color="primary" (click)="removeImg()">Rimuovi immagine</button>
              </td>
            </tr>
          </table>
        </div>

        <form [formGroup]="registerForm" (ngSubmit)="save()">

                 <mat-form-field appearance="fill">
                   <mat-label class="text-sm">Catalogo</mat-label>
                   <mat-select formControlName="selectedValueCatalogo" name="catalogo" class="text-sm">
                     <mat-option *ngFor="let catalogo of cataloghi" [value]="catalogo.Nome">
                       {{catalogo.Nome}}
                     </mat-option>
                   </mat-select>
                 </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Id" class="example-full-width">
                          <mat-label class="text-sm">Id</mat-label>
                          <input matInput placeholder="Id" formControlName="Id" name="Id" readOnly="true">
                </mat-form-field>
<!--
                <mat-form-field [style.display]="getConfigurazione().Catalogo" class="example-full-width">
                          <mat-label class="text-sm">Catalogo</mat-label>
                          <input matInput placeholder="Catalogo" formControlName="Catalogo" name="Catalogo" readOnly="true">
                </mat-form-field>
-->
                <mat-form-field [style.display]="getConfigurazione().Codicecatalogo" class="example-full-width">
                          <mat-label class="text-sm">Codicecatalogo</mat-label>
                          <input matInput placeholder="Codicecatalogo" formControlName="Codicecatalogo" name="Codicecatalogo" readOnly="true">
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Codicearticolo" class="example-full-width">
                          <mat-label class="text-sm">Codice articolo</mat-label>
                          <input matInput placeholder="Codicearticolo" formControlName="Codicearticolo" name="Codicearticolo">
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Descrizione" class="example-full-width">
                          <mat-label class="text-sm">Descrizione</mat-label>
                          <input matInput placeholder="Descrizione" formControlName="Descrizione" name="Descrizione">
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Categoria" class="example-full-width">
                          <mat-label class="text-sm">Categoria</mat-label>
                          <input matInput placeholder="Categoria" formControlName="Categoria" name="Categoria">
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Unitamisura" class="example-full-width">
                          <mat-label class="text-sm">Unita di misura</mat-label>
                          <mat-select formControlName="selectedValueUnitamisura" name="Unitamisura" class="text-sm">
                            <mat-option *ngFor="let unitamisura of udms" [value]="unitamisura.Nome">
                              {{unitamisura.Nome}}
                            </mat-option>
                          </mat-select>
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Costo" class="example-full-width">
                          <mat-label class="text-sm">Costo</mat-label>
                          <input matInput placeholder="Costo" formControlName="Costo" name="Costo" (keyup)="manageChangeCosto($event)">
                </mat-form-field>


                <mat-form-field appearance="fill">
                  <mat-label class="text-sm">IVA %</mat-label>
                  <mat-select formControlName="selectedValueIva" name="iva" class="text-sm" (selectionChange)="manageChangeIva()">
                    <mat-option *ngFor="let iva of ivas" [value]="iva.Valore">
                      {{iva.Valore}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Prezzo" class="example-full-width">
                          <mat-label class="text-sm">Prezzo</mat-label>
                          <input matInput placeholder="Prezzo" formControlName="Prezzo" (keyup)="manageChangePrezzo($event)" name="Prezzo">
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Note" class="example-full-width">
                          <mat-label class="text-sm">Note</mat-label>
                          <input matInput placeholder="Note" formControlName="Note" name="Note" >
                </mat-form-field>

                <mat-form-field [style.display]="getConfigurazione().Giacenza" class="example-full-width">
                          <mat-label class="text-sm">Giacenza</mat-label>
                          <input matInput placeholder="Giacenza" formControlName="Giacenza" (keyup)="manageChangeGiacenza($event)" name="Giacenza" >
                </mat-form-field>


        </form>
      </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="save()">Salva</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel()">Cancella</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

  </mat-card>
